import clsx from 'clsx';
import React from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import ArticleImage from '@components/FeedItems/ArticleImage';
import Highlight from '@components/FeedItems/Highlight';
import { Author } from '@interfaces/authors';
import { article_path } from '@routes';

import ArticleWrapper from '../FeedItems/ArticleWrapper';

interface StoryItemProps {
  authors: Author[];
  highlight: string;
  id: number;
  isPro: boolean;
  picture?: string;
  publishedAt: string;
  slug: string;
  title: string;
  withCopyOption?: boolean;
}

const StoryItem = ({
  authors,
  highlight,
  id,
  isPro,
  picture,
  publishedAt,
  slug,
  title,
  withCopyOption = false,
}: StoryItemProps) => {
  const articleUrl = `${window.location.origin}${article_path(slug)}`;

  return (
    <ArticleWrapper articleId={id} articleAuthors={authors} className="w-full flex-col">
      <ArticleImage
        className="aspect-[16/9] !h-[calc((100vw_-_32px)*9/16)] min-w-full leading-[0] sm:!h-auto"
        id={id}
        isPro={isPro}
        picture={picture}
        sizes="(min-width: 992px) 250px, (min-width: 480px) 600px, 400px"
        slug={slug}
        title={title}
      />
      {highlight && (
        <Highlight
          highlight={highlight}
          className="!mb-0 mt-10 font-suisse-intl-mono !text-caption-sm"
        />
      )}
      <ArticleHeader
        className={clsx('text-headline-xxs', { 'mt-10': !highlight })}
        title={title}
        slug={slug}
      />
      <Byline
        authors={authors}
        authorsClassName="author-name-related-story"
        publishedAt={publishedAt}
        linkToCopy={withCopyOption ? articleUrl : null}
        timeFromNow={!withCopyOption}
      />
    </ArticleWrapper>
  );
};

export default StoryItem;
